"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetLazyComponentPublic = exports.WidgetLazyComponentLoader = void 0;
const tslib_1 = require("tslib");
const ExpressCheckoutWidget_1 = require("@wix/cashier-core/dist/src/services/ExpressCheckoutWidget");
const react_1 = tslib_1.__importDefault(require("react"));
const logger_1 = require("@wix/web-bi-logger/dist/src/logger");
const react_module_container_1 = require("react-module-container");
const mbMinified_1 = require("@wix/cashier-common/dist/src/rmc-fork/mbMinified");
const constants_1 = require("../constants");
const InteractionName_1 = require("../types/InteractionName");
const perfNow_1 = require("../utils/perfNow");
const preloadData_1 = require("../utils/preloadData");
const constants_2 = require("./fedopsLogger/constants");
const createFedopsLogger_1 = require("./fedopsLogger/createFedopsLogger");
const config_1 = require("./config");
const applyVersionOverride_1 = require("./applyVersionOverride");
/**
 * @class WidgetLazyComponentLoader
 * Starts loading lazy component for Express Checkout Widget
 * to be able for us to change lazy component without Consumer
 * notification.
 */
class WidgetLazyComponentLoader extends react_module_container_1.ReactLazyComponent {
    static buildFiles(props) {
        return [
            `${props.widgetSettings.widgetStaticsBaseUrl}${constants_1.WIDGET_BUNDLE_FILE_NAME}${(0, mbMinified_1.mbMinified)()}.css`,
            `${props.widgetSettings.widgetStaticsBaseUrl}${constants_1.WIDGET_BUNDLE_FILE_NAME}.bundle${(0, mbMinified_1.mbMinified)()}.js`,
        ];
    }
    constructor(props) {
        super(props, {
            component: config_1.WIDGET_ID,
            files: WidgetLazyComponentLoader.buildFiles(props),
            crossorigin: true,
            // react-module-container throws error during unmount phase for JS files loaded by requirejs.
            // https://github.com/wix-incubator/react-module-container/blob/master/src/tag-appender.js#L119
            // In React 18 this error leads to fully broken layout.
            // Unset this when RMC will support React 18
            unloadStylesOnDestroy: false,
        });
        this.props.fedopsLogger.appLoadingPhaseStart(InteractionName_1.PhaseName.LoadMainBundle);
    }
}
exports.WidgetLazyComponentLoader = WidgetLazyComponentLoader;
/**
 * @class WidgetLazyComponentPublic
 * Main exported component for TPA. The main idea to use it
 * is to fetch settings for e-widget and to start fedops
 * interactions if consumer didn't start it.
 */
class WidgetLazyComponentPublic extends react_1.default.Component {
    constructor(props) {
        super(props);
        this._isMounted = true;
        this.state = {
            widgetSettings: null,
        };
        this.fedopsLogger =
            typeof props.fedopsLoggerFactory === 'function'
                ? props.fedopsLoggerFactory(constants_2.FEDOPS_LOGGER_ID)
                : (0, createFedopsLogger_1.createFedopsLogger)();
        const { appInstanceId, siteId, productId, visitorId, appDefId, consumerWidgetId } = this.props.meta;
        this.fedopsLogger.appLoadStarted();
        this.loaderStartTime = (0, perfNow_1.perfNow)();
        this.biLoggerFactory = (0, logger_1.factory)({ endpoint: 'cashier-ugc' });
        // we don't want to bring schema loggers to the lazy component to keep the bundle size small, thus inlining the "src" and "evid"
        this.biLoggerFactory.logger().log({
            src: 64,
            evid: 261,
            appInstanceId,
            widgetId: consumerWidgetId,
            currency: props.currency,
            msid: siteId,
            origin: props.domain,
            appId: appDefId,
            productId,
            visitorId,
        });
    }
    componentDidMount() {
        this.fetchPreloadData();
        this.fetchWidgetSettings();
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    fetchWidgetSettings() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.LoadWidgetSettings);
            this.fedopsLogger.appLoadingPhaseStart(InteractionName_1.PhaseName.LoadSettings);
            try {
                // Saving fetchWidgetSettings to static prop is useful when
                // component is re-rendered, so we don't need to request widget's meta info multiple times
                WidgetLazyComponentPublic.fetchWidgetSettingsPromise =
                    WidgetLazyComponentPublic.fetchWidgetSettingsPromise ||
                        new ExpressCheckoutWidget_1.ExpressCheckoutWidgetService({
                            baseURL: '/',
                            appInstance: this.props.meta.appInstance,
                            revalidateAppInstance: this.props.revalidateAppInstance,
                        }).fetchWidgetSettings();
                let widgetSettings = yield WidgetLazyComponentPublic.fetchWidgetSettingsPromise;
                this.fedopsLogger.interactionEnded(InteractionName_1.InteractionName.LoadWidgetSettings);
                widgetSettings = (0, applyVersionOverride_1.applyVersionOverride)(widgetSettings);
                if (this._isMounted) {
                    this.setState({ widgetSettings });
                }
            }
            catch (err) {
                // TODO: handle
            }
        });
    }
    fetchPreloadData() {
        this.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.LoadExperiments);
        this.fedopsLogger.interactionStarted(InteractionName_1.InteractionName.LoadPaymentMethods);
        this.preloadingData = (0, preloadData_1.preloadData)(this.props);
    }
    render() {
        const { widgetSettings } = this.state;
        if (widgetSettings === null) {
            return null;
        }
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(WidgetLazyComponentLoader, Object.assign({}, this.props, { preloadingData: this.preloadingData, fedopsLogger: this.fedopsLogger, biLoggerFactory: this.biLoggerFactory, widgetSettings: widgetSettings, loadInfo: {
                    loadStartTime: this.loaderStartTime,
                } }))));
    }
}
exports.WidgetLazyComponentPublic = WidgetLazyComponentPublic;
//# sourceMappingURL=WidgetLazyComponent.public.js.map